import fetcher from '@/utils/fetcher';
import { JsonWebTokenType } from '@/utils/token-manager';

interface PostJoinGeneralMemberProps {
  email: string;
  password: string;
  name: string;
}

interface PostJoinCreatorMemberProps {
  email: string;
  password: string;
  name: string;
  phone: string;
  belong: string;
  actualName: string;
}

/** 강사/일반 회원가입 */
const postJoinMember = async <T extends 'general' | 'creator'>(
  type: T,
  props: T extends 'general' ? PostJoinGeneralMemberProps : PostJoinCreatorMemberProps,
) => {
  try {
    // throw Error();
    const res = await fetcher.post('/api/auth/join', {
      data: { type, ...props },
    });
    return {
      data: res.data.data as JsonWebTokenType,
    };
  } catch (e: any) {
    const message = e.response?.data?.error?.message;
    if (message === 'email is not valid') {
      return { error: 'email is not valid' as const };
    }
    if (message === 'email is not verified') {
      return { error: 'email is not verified' as const };
    }
    if (message === 'email already exists') {
      return { error: 'email already exists' as const };
    }
    return { error: 'internal server error' as const };
  }
};

export default postJoinMember;
